import Immutable from 'immutable';

import ClassFactory from 'sharedreact/utils/ClassFactory';
import { translate } from 'sharedreact/utils/LanguageSupport';

let customerCounter = 1;

const Content: {
  id: string,
  cloudid: string | null,
  name: string,
  description: string | null,
  street1: string | null,
  street2: string | null,
  zip: string | null,
  city: string | null,
  country: string | null,
  contact1: string | null,
  email1: string | null,
  contact2: string | null,
  email2: string | null,
  contact3: string | null,
  email3: string | null,
  isNew: boolean
} = {
  id: '',
  cloudid: null,
  name: '',
  description: null,
  street1: null,
  street2: null,
  zip: null,
  city: null,
  country: null,
  contact1: null,
  email1: null,
  contact2: null,
  email2: null,
  contact3: null,
  email3: null,
  isNew: false
};

class Customer extends Immutable.Record(Content) {
  static createTemp (): Customer {
    const name = translate('common.general.title.new') + ' ' + customerCounter;
    customerCounter++;

    return new Customer({
      name: name,
      isNew: true
    });
  }

  static createEmptyTemp (): Customer {
    return new Customer({
      isNew: true
    });
  }

  static fromJS (json: object): Customer {
    return ClassFactory.createFromJson(json, Customer);
  }

  toJSCreateNew (): Object {
    const retval = Immutable.Map(this).toJS();
    retval.isNew = true;
    return retval;
  }

  toString (): Object {
    const retval = Immutable.toString;
    return retval;
  }

  get location (): string {
    let location = '';
    if (this.city) {
      location += this.city;
      if (this.country) {
        location += ', ';
      }
    }
    if (this.country) {
      location += this.country;
    }
    return location;
  }

  get isValid (): boolean {
    return !!this.name && !!this.id;
  }
}

export default Customer;
